export { ContactInfoPurposeType } from './generated/ContactInfoPurposeType.js';